$('.related-products-carousel').on('init', function () {
    setTimeout(() => {
        window.dispatchEvent(new Event("resize"))
    }, 200)
}).slick({
    slidesToShow: 4,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 300,
    pauseOnHover: true,
    arrows: false,
    centerMode: false,
    responsive: [{
        breakpoint: 992,
        settings: {
            slidesToShow: 3,
        }
    }, {
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
        }
    }, {
        breakpoint: 767,
        settings: {
            slidesToShow: 2,
            centerMode: true,
        }
    }, {
        breakpoint: 575,
        settings: {
            slidesToShow: 1,
            centerMode: true,
        }
    }],
});